import { useMediaQuery } from '@mui/material';

// A touch screen shorter than 500px: a phone held sideways (844x390 and similar).
// Wider than sm, so it would otherwise get the desktop page layout with almost no
// height for the grids. `pointer: coarse` keeps mouse/trackpad desktops out of it,
// however short their window.
export const SHORT_TOUCH_QUERY = '(pointer: coarse) and (max-height: 500px)';
export const SHORT_TOUCH_MEDIA = `@media ${SHORT_TOUCH_QUERY}`;

// Phone layouts: below the `sm` breakpoint (600px), or a sideways phone. Use this
// as an sx key for phone-only CSS that must agree with useIsPhone (grid heights,
// sticky headers) — a `{ xs, sm }` breakpoint object only sees the width.
export const PHONE_MEDIA = `@media (max-width:599.95px), ${SHORT_TOUCH_QUERY}`;

// True on phones (see PHONE_MEDIA): stacked rows instead of tables, full-screen
// dialogs. The app shell's own mobile switch (temporary sidebar drawer, collapsible
// header) is `down('md')` plus sideways phones, in App.js / Header.jsx.
export default function useIsPhone() {
  // noSsr: correct on the very first render, so a phone never draws the desktop
  // layout first (the Calendar picks its initial view from this). Desktop: false
  // from the start, exactly as before.
  return useMediaQuery(PHONE_MEDIA, { noSsr: true });
}
